
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/history",
      function () {
        return require("private-next-pages/[locale]/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/history"])
      });
    }
  